import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsActivityList, goodsActivityCreate, goodsActivityUpdate, deleteGoodsActivity, goodsActivityStatus, getSellerList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import GoodsSelectComponent from '@/view/bianlidianManage/goods/goodsSelectComponent';
import SearchTerm from '@/components/searchTerm';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BianlidianActivity',
  components: {
    GoodsSelectComponent: GoodsSelectComponent,
    SearchTerm: SearchTerm
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      var _this$allStationMap$S;

      return (_this$allStationMap$S = _this.allStationMap[String(id)]) === null || _this$allStationMap$S === void 0 ? void 0 : _this$allStationMap$S.stationName;
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getGoodsActivityList,
      searchInfo: {
        // 按配置顺序显示
        'sellerId': '',
        'activityName': '',
        'goodsNo': '',
        'ruleType': '',
        'activityStatus': ''
      },
      loading: false,
      type: '',
      multipleSelection: [],
      fullReduceDialogVisible: false,
      fullDiscountDialogVisible: false,
      fullGiveDialogVisible: false,
      fullMoreDialogVisible: false,
      onePriceDialogVisible: false,
      viewFullReduceDialogVisible: false,
      viewFullDiscountDialogVisible: false,
      viewFullGiveDialogVisible: false,
      viewFullMoreDialogVisible: false,
      viewOnePriceDialogVisible: false,
      dialogTitle: '',
      dateRangeValueArr: [],
      goodsComponentFormData: {
        goodsType: '',
        dialogVisible: false,
        sellerId: '',
        selection: [],
        // 回显，如果有数据，组件默认勾选
        activityGoodsMoney: '0',
        activityCostMoney: '0'
      },
      formData: {},
      publicRules: {
        sellerId: [{
          required: true,
          message: '请选择商店',
          trigger: 'blur'
        }],
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        ruleTypeSub: [{
          required: true,
          message: '请选择满减方式',
          trigger: 'blur'
        }],
        isAllGoods: [{
          required: true,
          message: '请选择商品',
          trigger: 'blur'
        }],
        dateRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            debugger;

            if (_this.dateRangeValueArr.length !== 2) {
              callback(new Error('请选择时间范围'));
            } else {
              callback();
            }
          }
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])), {}, {
    // eslint-disable-next-line vue/return-in-computed-property
    getRule: function getRule() {
      debugger;
      return this.publicRules;
    }
  }),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this) {
                  // keepAlive=true beforeCreate不执行
                  _this = _this3;
                }

                _this3.formData = _this3.initData();
                _this3.searchInfo.shopActivityType = _this3.formData.shopActivityType;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        sellerId: '',
        sellerName: '',
        activityName: '',
        ruleType: 1,
        ruleTypeSub: 2,
        startTime: '',
        endtime: '',
        isAllGoods: 2,
        ruleRemark: '',
        goodsNo: '',
        moneySource: 1,
        // 写死
        discountLevel: 2,
        // 写死
        shopActivityType: 2,
        // 写死
        activityRuleSingle: [this.initActivityRuleSingle()],
        activityRuleList: [this.initActivityRuleSingle()],
        activityGoodsList: [],
        // 活动商品
        giveGoodsList: [],
        // 赠品
        moreGoodsList: [] // 加价购商品

      };
      return formdata;
    },
    initActivityRuleSingle: function initActivityRuleSingle() {
      return {
        limits: '',
        discount: '',
        discountMax: '',
        extraAddmoney: '',
        onePrice: ''
      };
    },
    // 条件搜索前端看此方法
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.searchInfo.shopActivityType = _this4.formData.shopActivityType;
                _this4.loading = true;

                _this4.getTableData();

                _this4.loading = false;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 选择商品-确定
    goodsSelDialogOk: function goodsSelDialogOk(res) {
      var that = this;
      that.goodsComponentFormData.dialogVisible = false;

      if (res && res.length > 0) {
        res.forEach(function (item) {
          item.goodsNum = 1;

          if (that.goodsComponentFormData.goodsType == 'activityGoods') {
            var isExit = false;
            that.formData.activityGoodsList.forEach(function (item2) {
              if (item2.spuNo == item.spuNo) {
                isExit = true;
              }
            });

            if (!isExit) {
              that.formData.activityGoodsList.push(JSON.parse(JSON.stringify(item)));
            }
          }

          if (that.goodsComponentFormData.goodsType == 'onePriceGoods') {
            var _isExit = false;
            that.formData.activityGoodsList.forEach(function (item2) {
              if (item2.spuNo === item.spuNo) {
                _isExit = true;
              }
            });

            if (!_isExit) {
              that.formData.activityGoodsList.push(JSON.parse(JSON.stringify(item)));
            }
          }

          if (that.goodsComponentFormData.goodsType == 'giveGoods') {
            var _isExit2 = false;
            that.formData.giveGoodsList.forEach(function (item2) {
              if (item2.spuNo === item.spuNo) {
                _isExit2 = true;
              }
            });

            if (!_isExit2) {
              that.formData.giveGoodsList.push(JSON.parse(JSON.stringify(item)));
            }
          }

          if (that.goodsComponentFormData.goodsType == 'moreGoods') {
            var _isExit3 = false;
            that.formData.moreGoodsList.forEach(function (item2) {
              if (item2.spuNo === item.spuNo) {
                _isExit3 = true;
              }
            });

            if (!_isExit3) {
              that.formData.moreGoodsList.push(JSON.parse(JSON.stringify(item)));
            }
          }
        });
      }

      that.computeGoodsPrice();
    },
    // 计算商品原价
    computeGoodsPrice: function computeGoodsPrice() {
      var that = this;

      if (that.formData.activityGoodsList) {
        var goodsLatestCost = 0;
        var goodsPrice = 0;
        that.formData.activityGoodsList.forEach(function (item) {
          goodsLatestCost = goodsLatestCost + parseFloat(item.goodsLatestCost) * (item.goodsNum && parseFloat(item.goodsNum) > 0 ? parseFloat(item.goodsNum) : 1);
          goodsPrice = goodsPrice + parseFloat(item.goodsPrice) * (item.goodsNum && parseFloat(item.goodsNum) > 0 ? parseFloat(item.goodsNum) : 1);
        });
        that.goodsComponentFormData.activityCostMoney = goodsLatestCost.toFixed(2);
        that.goodsComponentFormData.activityGoodsMoney = goodsPrice.toFixed(2);
      } else {
        that.goodsComponentFormData.activityCostMoney = 0;
        that.goodsComponentFormData.activityGoodsMoney = 0;
      }
    },
    // 选择商品-关闭
    goodsSelDialogClose: function goodsSelDialogClose() {
      this.goodsComponentFormData.dialogVisible = false;
    },
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.onView(row);
    },
    // 满减
    onAddFullReduce: function onAddFullReduce() {
      this.type = 'addFullReduce';
      this.fullReduceDialogVisible = true;
      this.dialogTitle = '新增满减活动';
      this.formData.ruleType = 2;
    },
    // 满折
    onAddFullDiscount: function onAddFullDiscount() {
      this.type = 'addFullDiscount';
      this.fullDiscountDialogVisible = true;
      this.dialogTitle = '新增满折活动';
      this.formData.ruleType = 4;
      this.formData.ruleTypeSub = 1;
    },
    // 满赠
    onAddFullGive: function onAddFullGive() {
      this.type = 'addFullGive';
      this.fullGiveDialogVisible = true;
      this.dialogTitle = '新增满赠活动';
      this.formData.ruleType = 3;
    },
    // 加价购
    onAddFullMore: function onAddFullMore() {
      this.type = 'addFullMore';
      this.fullMoreDialogVisible = true;
      this.dialogTitle = '新增加价购活动';
      this.formData.ruleType = 1;
    },
    // 套餐
    onAddOnePrice: function onAddOnePrice() {
      this.type = 'addOnePrice';
      this.onePriceDialogVisible = true;
      this.dialogTitle = '新增一口价套餐活动';
      this.formData.ruleType = 5;
      this.formData.isAllGoods = 2;
    },
    onView: function onView(row) {
      var that = this;

      if (row.ruleType == 2) {
        that.type = 'viewFullReduce';
        this.dialogTitle = '查看满减活动';
        this.viewFullReduceDialogVisible = true;
      }

      if (row.ruleType == 4) {
        that.type = 'viewFullDiscount';
        this.dialogTitle = '查看满折活动';
        this.viewFullDiscountDialogVisible = true;
      }

      if (row.ruleType == 3) {
        that.type = 'viewFullGive';
        this.dialogTitle = '查看满赠活动';
        this.viewFullGiveDialogVisible = true;
      }

      if (row.ruleType == 1) {
        that.type = 'viewFullMore';
        this.dialogTitle = '查看加价购活动';
        this.viewFullMoreDialogVisible = true;
      }

      if (row.ruleType == 5) {
        that.type = 'viewOnePrice';
        this.dialogTitle = '查看一口价套餐活动';
        this.viewOnePriceDialogVisible = true;
      }

      this.handleViewOrUpdate(row);
    },
    onUpdate: function onUpdate(row) {
      var that = this;

      if (row.ruleType == 2) {
        that.type = 'updateFullReduce';
        that.fullReduceDialogVisible = true;
        that.dialogTitle = '变更满减活动';
      }

      if (row.ruleType == 4) {
        that.type = 'updateFullDiscount';
        that.fullDiscountDialogVisible = true;
        that.dialogTitle = '变更满折活动';
      }

      if (row.ruleType == 3) {
        that.type = 'updateFullGive';
        that.fullGiveDialogVisible = true;
        that.dialogTitle = '变更满赠活动';
      }

      if (row.ruleType == 1) {
        that.type = 'updateFullMore';
        that.fullMoreDialogVisible = true;
        that.dialogTitle = '变更加价购活动';
      }

      if (row.ruleType == 5) {
        that.type = 'updateOnePrice';
        that.onePriceDialogVisible = true;
        that.dialogTitle = '变更一口价套餐活动';
        that.formData.isAllGoods = 2;
      }

      that.handleViewOrUpdate(row);
      that.$forceUpdate();
    },
    handleViewOrUpdate: function handleViewOrUpdate(row) {
      var that = this;
      row.activityRuleSingle = [];
      that.formData = JSON.parse(JSON.stringify(row));

      if (row.ruleTypeSub == 2 && row.activityRuleList && row.activityRuleList.length > 0) {
        that.formData.activityRuleSingle.push(JSON.parse(JSON.stringify(row.activityRuleList[0])));
      } else {
        that.formData.activityRuleSingle.push(this.initActivityRuleSingle());
      }

      that.formData.giveGoodsList = []; // 赠品

      that.formData.moreGoodsList = []; // 加价购商品

      if (that.formData.activityGoodsList && that.formData.activityGoodsList.length > 0) {
        var activityGoodsList = []; // 活动商品

        that.formData.activityGoodsList.forEach(function (item) {
          if (item.activityGoodsType == 0) {
            // 活动商品
            activityGoodsList.push(item);
          }

          if (item.activityGoodsType == 1) {
            // 赠品
            that.formData.giveGoodsList.push(item);
          }

          if (item.activityGoodsType == 2) {
            // 加价购商品
            that.formData.moreGoodsList.push(item);
          }
        });
        that.formData.activityGoodsList = activityGoodsList;
      }

      if (!that.formData.activityGoodsList) {
        that.formData.activityGoodsList = []; // 活动商品，初始化以便修改时有该对象
      }

      that.computeGoodsPrice(); // 不能用以下写法，回显会不展示
      // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.startTime)
      // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.endTime)

      that.dateRangeValueArr = [that.$options.filters.formatDate(row.startTime), that.$options.filters.formatDate(row.endTime)];
      that.formData.startTime = that.$options.filters.formatDate(row.startTime);
      that.formData.endTime = that.$options.filters.formatDate(row.endTime);
      that.formData.sellerName = that.$options.filters.getSellerName(row.sellerId);
    },
    onAble: function onAble(row) {
      var that = this;
      goodsActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 1
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    onDisable: function onDisable(row) {
      var that = this;
      goodsActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 2
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    onDelete: function onDelete(row) {
      var that = this;
      that.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteGoodsActivity({
          'activityNo': row.activityNo,
          'sellerId': row.sellerId
        }).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.enterDialogRepose(res);
          }
        }, function (error) {});
      }).catch(function (err) {});
    },
    // 选择便利店
    onSellerChange: function onSellerChange() {
      var that = this; // eslint-disable-next-line eqeqeq

      if (that.formData.sellerId != that.goodsComponentFormData.sellerId) {
        that.formData.activityGoodsList = [];
        that.formData.giveGoodsList = [];
        that.formData.moreGoodsList = [];
        that.goodsComponentFormData.activityGoodsMoney = 0;
        that.goodsComponentFormData.activityCostMoney = 0;
      }

      this.$forceUpdate();
    },
    // 阶梯规则添加
    onAddRule: function onAddRule(index) {
      var that = this;
      that.formData.activityRuleList.splice(index + 1, 0, that.initActivityRuleSingle());
    },
    // 阶梯规则删除
    onDeleteRule: function onDeleteRule(index) {
      var that = this;

      if (that.formData.activityRuleList.length == 1) {
        return;
      }

      that.formData.activityRuleList.splice(index, 1);
    },
    // 添加商品
    onAddGoods: function onAddGoods(goodsType) {
      var that = this;

      if (!that.formData.sellerId || that.formData.sellerId === '') {
        that.$message({
          type: 'warning',
          message: '请选择便利店'
        });
        return;
      }

      that.goodsComponentFormData.dialogVisible = true;
      that.goodsComponentFormData.sellerId = that.formData.sellerId;
      that.goodsComponentFormData.goodsType = goodsType;
    },
    // 删除活动商品
    onDelActivityGoods: function onDelActivityGoods(row) {
      var that = this; // eslint-disable-next-line eqeqeq

      that.formData.activityGoodsList = that.formData.activityGoodsList.filter(function (item) {
        return item.ID != row.ID;
      });
      that.computeGoodsPrice();
    },
    // 删除赠品
    onDelGiveGoods: function onDelGiveGoods(row) {
      var that = this; // eslint-disable-next-line eqeqeq

      that.formData.giveGoodsList = that.formData.giveGoodsList.filter(function (item) {
        return item.ID != row.ID;
      });
      this.$forceUpdate();
    },
    // 删除加价商品
    onDelMoreGoods: function onDelMoreGoods(row) {
      var that = this; // eslint-disable-next-line eqeqeq

      that.formData.moreGoodsList = that.formData.moreGoodsList.filter(function (item) {
        return item.ID != row.ID;
      });
    },
    closeDialog: function closeDialog() {
      this.fullReduceDialogVisible = false;
      this.fullDiscountDialogVisible = false;
      this.fullGiveDialogVisible = false;
      this.fullMoreDialogVisible = false;
      this.onePriceDialogVisible = false;
      this.viewFullReduceDialogVisible = false;
      this.viewFullDiscountDialogVisible = false;
      this.viewFullGiveDialogVisible = false;
      this.viewFullMoreDialogVisible = false;
      this.viewOnePriceDialogVisible = false;
      this.type = '';
      this.dialogTitle = '';
      this.dateRangeValueArr = [];
      this.goodsComponentFormData = {
        dialogVisible: false,
        sellerId: '',
        selection: [],
        goodsType: '',
        activityGoodsMoney: '0',
        activityCostMoney: '0'
      };
      this.formData = this.initData();
      this.$forceUpdate();
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;

      switch (that.type) {
        case 'addFullReduce':
          if (that.formData.ruleTypeSub == 2) {
            that.formData.activityRuleList = [that.formData.activityRuleSingle[0]];
          }

          that.handleAdd('fullReduceFormData');
          break;

        case 'updateFullReduce':
          if (that.formData.ruleTypeSub == 2) {
            that.formData.activityRuleList = [that.formData.activityRuleSingle[0]];
          }

          that.handleUpdate('fullReduceFormData');
          break;

        case 'addFullDiscount':
          that.handleAdd('fullDiscountFormData');
          break;

        case 'updateFullDiscount':
          that.handleUpdate('fullDiscountFormData');
          break;

        case 'addFullGive':
          that.handleAdd('fullGiveFormData');
          break;

        case 'updateFullGive':
          that.handleUpdate('fullGiveFormData');
          break;

        case 'addFullMore':
          that.handleAdd('fullMoreFormData');
          break;

        case 'updateFullMore':
          that.handleUpdate('fullMoreFormData');
          break;

        case 'addOnePrice':
          that.handleAdd('onePriceFormData');
          break;

        case 'updateOnePrice':
          that.handleUpdate('onePriceFormData');
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd(refFormData) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                that.$refs[refFormData].validate(function (valid) {
                  if (valid && that.validFormData()) {
                    debugger;
                    goodsActivityCreate(that.getParam()).then(function (res) {
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 变更保存
    handleUpdate: function handleUpdate(refFormData) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;
                that.$refs[refFormData].validate(function (valid) {
                  debugger;

                  if (valid && that.validFormData()) {
                    debugger;
                    goodsActivityUpdate(that.getParam()).then(function (res) {
                      if (res.code === 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 公共校验函数
    validFormData: function validFormData() {
      var that = this;

      if (that.formData.isAllGoods == 2 && that.formData.activityGoodsList.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择活动商品'
        });
        return false;
      }

      if (that.formData.ruleType == 3 && (!that.formData.giveGoodsList || that.formData.giveGoodsList.length == 0)) {
        that.$message({
          type: 'warning',
          message: '请选择赠品'
        });
        return false;
      }

      if (that.formData.ruleType == 1 && (!that.formData.moreGoodsList || that.formData.moreGoodsList.length == 0)) {
        that.$message({
          type: 'warning',
          message: '请选择加价购商品'
        });
        return false;
      }

      return true;
    },
    getParam: function getParam() {
      var that = this;
      var formData = JSON.parse(JSON.stringify(that.formData));
      formData.startTime = that.dateRangeValueArr[0];
      formData.endTime = that.dateRangeValueArr[1];
      formData.moneySource = 1;
      formData.discountLevel = 2;
      formData.shopActivityType = 2; // 规则

      if (that.formData.activityRuleList && that.formData.activityRuleList.length > 0) {
        formData.activityRuleList.forEach(function (item) {
          item.activityNo = that.formData.activityNo;
        });
      } // 活动商品


      var activityGoodsList = [];

      if (formData.isAllGoods == 2 && formData.activityGoodsList && formData.activityGoodsList.length > 0) {
        formData.activityGoodsList.forEach(function (item) {
          item.activityGoodsType = 0;
          item.activityNo = that.formData.activityNo;
          delete item['ID'];
          activityGoodsList.push(item);
        });
      } // 赠品


      if (formData.giveGoodsList && formData.giveGoodsList.length > 0) {
        formData.giveGoodsList.forEach(function (item) {
          item.activityGoodsType = 1;
          item.activityNo = that.formData.activityNo;
          delete item['ID'];
          activityGoodsList.push(item);
        });
      } // 加价购商品


      if (formData.moreGoodsList && formData.moreGoodsList.length > 0) {
        formData.moreGoodsList.forEach(function (item) {
          item.activityGoodsType = 2;
          item.activityNo = that.formData.activityNo;
          delete item['ID'];
          activityGoodsList.push(item);
        });
      }

      delete formData['activityRuleSingle'];
      delete formData['giveGoodsList'];
      delete formData['moreGoodsList'];
      formData.activityGoodsList = activityGoodsList;
      return formData;
    }
  }
};